import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { FocusSelectOnDirective } from '../../../directives/focus-select.directive';
import { MatIconModule } from '@angular/material/icon';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'se-combo-cell-editor-popup',
    templateUrl: './combo-cell-editor-popup.component.html',
    styleUrls: ['./combo-cell-editor-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatIconModule,
        ReactiveFormsModule,
        FocusSelectOnDirective,
        TranslateModule,
    ],
})
export class ComboCellEditorPopupComponent {
    readonly comboFormControl = input.required<FormControl>();

    readonly cellReady = input.required<boolean>();

    readonly width = input.required<string>();

    readonly dataSource = input.required<any[]>();

    /**
     * it allows to specify which object property to show in drop down list.
     */
    readonly viewValueFieldName = input<string>();

    /**
     * it allows to specify which object property to give back(ngModel).If it is null or undefined, the component gives back all the object.
     */
    readonly valueFieldName = input<string>();

    /**
     * (Optional default value false) it allows multi selection.
     */
    readonly multi = input.required<boolean>();

    /**
     * (Optional default value false) it allows to reset the cell value
     */
    readonly isResettable = input.required<boolean>();

    compareWithFn(item1: any, item2: any) {
        item1 = item1 || '';
        item2 = item2 || '';
        if (typeof item1 === 'string' && typeof item2 === 'string') {
            return item1 === item2;
        }
        if (typeof item1 === 'object' && typeof item2 === 'object') {
            if ('Id' in item1 && 'Id' in item2) {
                return item1.Id === item2.Id;
            }
            let result = true;
            Object.entries(item1).forEach((prop) => {
                result = result && prop[1] === item2[prop[0]];
            });
            return result;
        }
    }

    onCleanCombo(event: Event) {
        const comboFormControl = this.comboFormControl();
        comboFormControl.setValue(null);
        event.stopPropagation();
    }
}
